import React, { useEffect, useState } from "react";
import Dashboard from "../../../CustomComponents/Property/Dashboard/Dashboard";
import CustomerHeader from "../CustomerHeader/CustomerHeader";
import CustomerSideBar from "../CustomerSideBar/CustomerSideBar";
import DashboardCustomer from "../DashboardCustomer/DashboardCustomer";

function CustomerDashboard() {
  return (
    <>
      <div className="sidebar_main_div new_sidebar_main_div">
        <CustomerSideBar />
        <div className="agent-info-container">
          <CustomerHeader />
          <div>
            <DashboardCustomer text={false} />
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomerDashboard; 
